<template>
    <div
        id="remoteUploadDialog"
        class="w-100 h-100 d-flex flex-column align-items-center justify-content-end position-relative"
    >
        <div class="position-absolute top-0 left-0 pt-2 pl-3" v-if="mode !== 'remote_url'">
            <RouterLink
                id="backToUploadButton"
                :to="{ name: 'file-upload' }"
                tag="button"
                class="btn text-white font-size-125 d-inline-flex align-items-center"
            >
                <i class="fa fa-arrow-left font-size-200 mr-1"></i>
                <span>{{ 'Back' | trans }}</span>
            </RouterLink>
        </div>

        <div class="font-size-150 font-weight-bold py-3 mb-2"><i class="fa fa-link"></i> {{ 'Enter URL' | trans }}</div>

        <div class="font-size-125 w-100 px-5 text-center">
            <div>
                <input
                    id="remoteUrlInput"
                    type="text"
                    placeholder="http://www.example.com/examplefile.pdf"
                    onfocus="this.placeholder=''"
                    onblur="this.placeholder='http://www.example.com/examplefile.pdf'"
                    class="w-100 rounded no-border py-2 px-3 font-size-125"
                    v-model.trim="remoteUrl"
                    @keydown.enter="addRemoteUrl"
                />
            </div>

            <button
                id="addRemoteUrlButton"
                class="btn-success btn font-weight-bold text-uppercase mt-4 py-2 vue-uploadbox-remote-add-button"
                @click.stop.prevent="addRemoteUrl"
            >
                <i class="fa fa-plus"></i> {{ 'Add' | trans }}
            </button>

            <div class="font-size-125 py-3 text-center">
                <a
                    :title="'Specify a downloader that fits your task' | trans"
                    href="javascript:void(0)"
                    class="text-white px-2 cursor-pointer"
                    @click.stop.prevent="openSettingsModal"
                >
                    <i class="fa fa-cog"></i> {{ 'Settings' | trans }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import {
    testIsTrimmedStringEmpty,
    testIsTrimmedStringNotEmpty,
    testIsUndefined,
} from '../../../../lib/test-and-assert/test-base';
import { pageNotification } from '../../../../qaamgo/helper/notify';
import { globalLogger } from '../../../../qaamgo/helper/global-logger';
import TransFilter from '../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { getGlobalUploader } from '../../global-uploader';

export default {
    name: 'RemoteUrlView',
    inject: ['mode'],
    mixins: [TransFilter],
    computed: {
        isRemoteUrlValid() {
            if (testIsTrimmedStringNotEmpty(this.remoteUrl) && this.remoteUrl.startsWith('oc-source')) {
                return true;
            }

            return /^(?:\w+:\/\/)?[\w.-]+(?:\.[\w.-]+)+/.test(this.remoteUrl) && !/^(file:\/\/).*/.test(this.remoteUrl);
        },
    },
    methods: {
        openSettingsModal() {
            $('#selectDownloader').modal('show');
        },
        addRemoteUrl() {
            if (testIsTrimmedStringNotEmpty(this.remoteUrl)) {
                this.remoteUrl = this.remoteUrl.trim();
            }

            if (testIsTrimmedStringEmpty(this.remoteUrl)) {
                pageNotification.error('Please enter a URL.');

                return;
            }

            if (!this.isRemoteUrlValid) {
                pageNotification.error(
                    'We are not able to download this file, please try to upload the file directly instead.'
                );

                globalLogger.log('External url validation failed');

                return;
            }

            const uploader = getGlobalUploader();

            if (uploader === null) {
                pageNotification.error('Something went wrong, please try again later!');
                globalLogger.log('addRemoteUrl - no uploader defined');

                return;
            }

            let engine = $('#inputEngine').val();

            if (testIsUndefined(engine)) {
                engine = 'auto';
            }

            uploader.clickRemoteUrl(this.remoteUrl, engine);
            globalLogger.log('External url validation successful');

            this.remoteUrl = '';
        },
    },
    data() {
        return {
            remoteUrl: '',
        };
    },
};
</script>
